module.exports = __webpack_public_path__ + "static/img/header_arrow.2b07ae2a.svg";